<div class="dashboard_bred_crumb">
    <ul>
        <!-- <li><img src="../../../../../assets/images/icons/bred_crumb_arrow.svg" alt=""></li>
     
      <li>My Jobs</li> -->
        <li><img src="../../../../../assets/images/icons/bred_crumb_arrow.svg"></li>
        <li>Talent Listing</li>
    </ul>
</div>

<section class="master_add_sec filterSec">
    <form class="form-section">
        <div>
            <div class="filterJoblist aligned-container">
                <div class="d-flex">
                    <div class="job-status-tabs" *ngIf="loginDetails.type == 'ADMIN'">
                        <button type="button" class="status-tab" [class.active]="currentAdminTab === 'ALL'"
                            (click)="onAdminTabChange('ALL')">
                            All <span class="count-badge">{{ tabAdminCounts.ALL || 0 }}</span>
                        </button>

                        <button type="button" class="status-tab" [class.active]="currentAdminTab === 'PENDING'"
                            (click)="onAdminTabChange('PENDING')">
                            Pending <span class="count-badge">{{ tabAdminCounts.PENDING || 0 }}</span>
                        </button>

                        <button type="button" class="status-tab" [class.active]="currentAdminTab === 'APPROVE'"
                            (click)="onAdminTabChange('APPROVE')">
                            Approved <span class="count-badge">{{ tabAdminCounts.APPROVE }}</span>
                        </button>

                        <button type="button" class="status-tab" [class.active]="currentAdminTab === 'REJECT'"
                            (click)="onAdminTabChange('REJECT')">
                            Rejected <span class="count-badge">{{ tabAdminCounts.REJECTED }}</span>
                        </button>

                    </div>

                    <div class="job-status-tabs"
                        *ngIf="loginDetails.type === 'SUPPLIER' || loginDetails.type === 'PRACTICE'">
                        <button type="button" class="status-tab" [class.active]="currentUserTab === 'ALL'"
                            (click)="onUserTabChange('ALL')">
                            All <span class="count-badge">{{ tabUserCounts.ALL }}</span>
                        </button>

                        <button type="button" class="status-tab" [class.active]="currentUserTab === 'PENDING'"
                            (click)="onUserTabChange('PENDING')">
                            Pending <span class="count-badge">{{ tabUserCounts.PENDING }}</span>
                        </button>

                        <button type="button" class="status-tab" [class.active]="currentUserTab === 'APPROVE'"
                            (click)="onUserTabChange('APPROVE')">
                            Interested <span class="count-badge">{{ tabUserCounts.APPROVE }}</span>
                        </button>

                        <button type="button" class="status-tab" [class.active]="currentUserTab === 'REJECT'"
                            (click)="onUserTabChange('REJECT')">
                            Not Interested <span class="count-badge">{{ tabUserCounts.REJECTED }}</span>
                        </button>

                        <button type="button" class="status-tab" [class.active]="currentUserTab === 'CANCELLED'"
                            (click)="onUserTabChange('CANCELLED')">Cancelled
                            <span class="count-badge">{{ tabUserCounts.CANCELLED }}</span>
                        </button>

                    </div>




                    <!-- <button mat-stroked-button color="primary" (click)="toggleFilter()" class="ml-auto">
                        <mat-icon>filter_list</mat-icon> Filter
                    </button> -->
                    <button *ngIf="loginDetails.type === 'ADMIN'" type="button" mat-button class="table-filter-btn"
                        (click)="filterToggleAdmin(); $event.stopPropagation()" class="ml-auto">
                        <img *ngIf="!OpenFilterAdmin" src="../../../../../assets/images/icons/icon_edb_filter.svg"
                            width="16" height="16" style="margin-right: 5px;" />
                        <img *ngIf="OpenFilterAdmin" src="../../../../../assets/images/icons/icon_edb_close.svg"
                            width="14" height="14" style="margin-right: 5px;" />
                        Filter
                    </button>
                    <button *ngIf="loginDetails.type === 'SUPPLIER' || loginDetails.type === 'PRACTICE'" type="button"
                        mat-button class="table-filter-btn" (click)="filterToggleUser(); $event.stopPropagation()"
                        class="ml-auto">
                        <img *ngIf="!OpenFilterUser" src="../../../../../assets/images/icons/icon_edb_filter.svg"
                            width="16" height="16" style="margin-right: 5px;" />
                        <img *ngIf="OpenFilterUser" src="../../../../../assets/images/icons/icon_edb_close.svg"
                            width="14" height="14" style="margin-right: 5px;" />
                        Filter
                    </button>


                </div>
                <ng-container *ngIf="loginDetails.type === 'ADMIN'">
                    <section *ngIf="OpenFilterAdmin" class="basic-filter openclose-filter-sec"
                        (click)="$event.stopPropagation()">
                        <div class="filter-row">

                            <!-- Role -->
                            <mat-form-field appearance="outline">
                                <mat-label>Role</mat-label>
                                <input matInput name="role"
                                    (input)="suggestionAdmin($event.target.value, allRolesAdminSuggest, 'roleOptionsAdmin')"
                                    [(ngModel)]="profession_type" [matAutocomplete]="roleAuto" />
                                <mat-autocomplete #roleAuto="matAutocomplete" (optionSelected)="onAdminFilterChange()">
                                    <mat-option *ngFor="let role of roleOptionsAdmin" [value]="role">{{ role | titlecase
                                        }}</mat-option>
                                </mat-autocomplete>

                            </mat-form-field>

                            <!-- Status -->
                            <mat-form-field appearance="outline" *ngIf="currentAdminTab === 'ALL'">
                                <mat-label>Status</mat-label>
                                <input matInput name="status" [(ngModel)]="admin_status"
                                    (input)="suggestionAdmin($event.target.value, allStatusAdminSuggest, 'statusOptionsAdmin')"
                                    [matAutocomplete]="statusAuto" />
                                <mat-autocomplete #statusAuto="matAutocomplete"
                                    (optionSelected)="onAdminFilterChange()">
                                    <mat-option *ngFor="let status of statusOptionsAdmin" [value]="status">{{ status
                                        }}</mat-option>
                                </mat-autocomplete>
                            </mat-form-field>

                            <!-- Employment Type -->

                            <mat-form-field appearance="outline">
                                <mat-label>Employee Type</mat-label>
                                <input matInput name="Type" [(ngModel)]="work_type"
                                    (input)="suggestionAdmin($event.target.value, allEmpTypesAdminSuggest, 'empTypeOptionsAdmin')"
                                    [matAutocomplete]="empTypeAuto" />
                                <mat-autocomplete #empTypeAuto="matAutocomplete"
                                    (optionSelected)="onAdminFilterChange()">
                                    <mat-option *ngFor="let emp of empTypeOptionsAdmin" [value]="emp">{{ emp
                                        }}</mat-option>
                                </mat-autocomplete>
                            </mat-form-field>



                            <button mat-button class="clear-btn" type="button" (click)="clearAllAdminFilters()">
                                Clear
                            </button>
                        </div>
                    </section>
                </ng-container>
                <ng-container *ngIf="loginDetails.type === 'SUPPLIER' || loginDetails.type === 'PRACTICE'">
                    <section *ngIf="OpenFilterUser" class="basic-filter openclose-filter-sec"
                        (click)="$event.stopPropagation()">
                        <div class="filter-row">


                            <!-- Role -->
                            <mat-form-field appearance="outline">
                                <mat-label>Role</mat-label>
                                <input matInput name="role"
                                    (input)="suggestionUser($event.target.value, roleOptionsUserSuggest, 'roleOptionsUser')"
                                    [(ngModel)]="profession_type_user" [matAutocomplete]="roleAuto" />
                                <mat-autocomplete #roleAuto="matAutocomplete" (optionSelected)="onUserFilterChange()">
                                    <mat-option *ngFor="let role of roleOptionsUser" [value]="role">{{ role | titlecase
                                        }}</mat-option>
                                </mat-autocomplete>

                            </mat-form-field>

                            <!-- Status -->
                            <mat-form-field appearance="outline" *ngIf="currentUserTab === 'ALL'">
                                <mat-label>Status</mat-label>
                                <input matInput name="status"
                                    (input)="suggestionUser($event.target.value, statusOptionsUserSuggest, 'statusOptionsUser')"
                                    [(ngModel)]="hiring_status_user" [matAutocomplete]="statusAuto" />
                                <mat-autocomplete #statusAuto="matAutocomplete" (optionSelected)="onUserFilterChange()">
                                    <mat-option *ngFor="let status of statusOptionsUser" [value]="status">{{ status
                                        }}</mat-option>
                                </mat-autocomplete>
                            </mat-form-field>

                            <!-- Employment Type -->

                            <mat-form-field appearance="outline">
                                <mat-label>Employee Type</mat-label>
                                <input matInput name="Type"
                                    (input)="suggestionUser($event.target.value, empTypeOptionsUserSuggest, 'empTypeOptionsUser')"
                                    [(ngModel)]="work_type_user" [matAutocomplete]="empTypeAuto" />
                                <mat-autocomplete #empTypeAuto="matAutocomplete"
                                    (optionSelected)="onUserFilterChange()">
                                    <mat-option *ngFor="let emp of empTypeOptionsUser" [value]="emp">{{ emp
                                        }}</mat-option>
                                </mat-autocomplete>
                            </mat-form-field>


                            <button mat-button class="clear-btn" type="button" (click)="clearAllUserFilters()">
                                Clear
                            </button>
                        </div>
                    </section>
                </ng-container>


                <div class="create-job-btn" *ngIf="loginDetails.type === 'PROFESSIONAL'">
                    <button [routerLink]="['/profile/directory/job-profile-list']" type="submit"
                        class="btn btn-sm global-btn mat-button" mat-button>
                        Create Profile
                    </button>
                </div>

                <!-- <div *ngFor="let value of jobProfileData">
          <h2>{{value.job_location}}</h2>
        </div> -->


            </div>
        </div>

    </form>
</section>

<ng-container *ngIf="loginDetails.type === 'ADMIN'">
    <div infiniteScroll [infiniteScrollDistance]="10" [infiniteScrollThrottle]="100" (scrolled)="loadMoreAdminTalent()">

        <ng-container *ngIf="!loaderTalent"> 
        <ng-container *ngIf="talentListAdmin?.length > 0; else noDataAdmin">
        <section class="master_add_sec  mb-3" *ngFor="let jobUserdata of talentListAdmin; trackBy: trackByJobId">
            <div class="dashBoard-joblist-sec">
                <div style="cursor: pointer;" class="job-box-company-detail-dashboard d-flex mb-4"
                    (dblclick)="navigateToProfile(jobUserdata.dental_professional_id)">
                    <div>
                        <div>
                            <div class="jobcompanyLogo">
                            <ng-container *ngIf="!jobUserdata?.post_anonymously; else anonymousImgAdmin  "> 

                                <img *ngIf="jobUserdata?.profile_image?.length; else showLetter"
                                    [src]="jobUserdata.profile_image[0]?.url" class="profile-img">

                                <ng-template #showLetter>
                                    <div class="fallback-avatar">
                                        <span class="text-initials"> {{ getInitial(jobUserdata?.full_name) }} </span>
                                    </div>
                                </ng-template>

                            </ng-container>

                                <ng-template #anonymousImgAdmin>
                                    <ng-container *ngIf="jobUserdata?.post_anonymously">
                                        <img class="talent-avatars" *ngIf="jobUserdata?.dental_professional?.gender === 'male'; else femalePlaceholder"
                                            src="../../../../../../../assets/images/social/male_avatar.png " />
                                        <ng-template #femalePlaceholder>
                                            <img class="talent-avatars"
                                                *ngIf="jobUserdata?.dental_professional?.gender === 'female';else defaultPlaceholder"
                                                src="../../../../../../../assets/images/social/female_avatar.png" />
                                        </ng-template>
                                        <ng-template #defaultPlaceholder> 
                                            <div style="background-color:#0f0e0e26; height: 100%;width: 100%;border-radius: 50%;">
                                                </div>
                                     </ng-template>
                                
                                    </ng-container>
                                </ng-template>
                                
                            </div>
                        </div>

                    </div>
                    <div class="ml-3">
                        <h3 >{{jobUserdata.profession_type}}</h3>

                        <h4 *ngIf="!jobUserdata?.post_anonymously;">{{jobUserdata.full_name }}</h4>

                        <h4>{{jobUserdata.state }}</h4>

                    </div>
                    <div class="d-flex align-self-baseline flex-column ml-auto text-right">
                        <div class="mb-auto ml-auto">


                            <button mat-icon-button [matMenuTriggerFor]="menu3" (click)="$event.stopPropagation()">
                                <mat-icon>more_horiz</mat-icon>
                            </button>


                            <mat-menu #menu3="matMenu" class="table-action-btn">
                                <button *ngIf="jobUserdata?.admin_status !== 'APPROVE' " type="button" class="view"
                                    mat-menu-item
                                    (click)="$event.stopPropagation(); changeStatusTalent('APPROVE',jobUserdata.id)">
                                    <span>Approve</span>
                                </button>
                                <button type="button" class="view" mat-menu-item
                                    *ngIf="jobUserdata?.admin_status !== 'REJECT' "
                                    (click)="$event.stopPropagation(); changeStatusTalent('REJECT',jobUserdata.id)">
                                    <span>Reject</span>
                                </button>

                                <button type="button" class="view" mat-menu-item
                                    (click)="viewTalentProfile(jobUserdata?.id)">
                                    <span>View Talent Profile</span>
                                </button>

                                <!-- <button 
                             type="button" class="view" mat-menu-item
                                [routerLink]="['/jobseek/talentis-details', jobUserdata.dental_professional_id]">
                                <span>Approve & Verified</span>
                            </button> -->

                            </mat-menu>

                        </div>
                        <p class="mt-5">Created : {{jobUserdata.created_at | date : 'dd-MM-yyyy'}}</p>
                    </div>
                </div>
                <span class="EmploymentType" *ngIf="jobUserdata.work_type">
                    <span class="fullTime" *ngFor="let type of jobUserdata.work_type">
                        {{ type }}
                    </span>
                </span>



                <div class="d-flex" style="margin-top: 15px;">
                    <div class="mr-auto d-flex align-items-center flex-wrap" style="min-width: 180px; gap: 8px">
                        <div class="orgThemeBtn">{{ jobUserdata?.admin_status }}</div>
                        <ng-template #emptySpace>
                            <div style="height: 36px"></div>
                        </ng-template>
                    </div>
                    <div class="blueThemeBtn"
                        [routerLink]="['/jobseek/talentis-details', jobUserdata.dental_professional_id]">
                        View Details
                    </div>
                </div>

                <hr>

            </div>
        </section>
        </ng-container>

        <div *ngIf="loadingAdmin && talentListAdmin.length > 0" class="loading-more" fxLayout="row"
                fxLayoutAlign="center center">
                <img src="../../../../../assets/images2/loader.gif" alt="Loading more..." loading="lazy" width="80px" />
            </div>

           <div *ngIf="endOfDataAdmin && !loadingAdmin && talentListAdmin?.length > 0" class="text-center py-3 text-muted">
            You've reached the end — no more talents to display
        </div>


        </ng-container>

 

        <ng-template #noDataAdmin>
            <div class="no-data-wrapper">
                <img src="../../../../../assets/images/icons/no_tasks.svg" alt="No records illustration"
                    class="no-data-image" />
                <div class="no-record-text"> No
                    <span *ngIf="currentAdminTab ==='APPROVE' ">approved</span>
                    <span *ngIf="currentAdminTab ==='REJECT' ">rejected</span>
                    <span *ngIf="currentAdminTab ==='PENDING' ">pending</span> talents available at the moment
                </div>
            </div>
        </ng-template>

    </div>

</ng-container>

<ng-container *ngIf="loginDetails.type === 'SUPPLIER'|| loginDetails.type === 'PRACTICE'">
    <div infiniteScroll [infiniteScrollDistance]="10" [infiniteScrollThrottle]="100" (scrolled)="loadMoreHiringList()">
       <ng-container *ngIf="!loaderTalent"> 
        <ng-container *ngIf="hiringListUser?.length > 0; else noDataUser">
        <section class="master_add_sec  mb-3" *ngFor="let jobUserdata of hiringListUser; trackBy: trackByJobId">
            <div class="dashBoard-joblist-sec">
                <div style="cursor: pointer;" class="job-box-company-detail-dashboard d-flex mb-4"
                    (dblclick)="navigateToProfile(jobUserdata?.job_profiles?.dental_professional_id)">
                    <div>
                        <div class="jobcompanyLogo">
                              <ng-container *ngIf="!jobUserdata?.job_profiles?.post_anonymously; else anonymousImgUser  "> 
                            <img *ngIf="jobUserdata?.job_profiles?.profile_image?.length; else showLetter"
                                [src]="jobUserdata?.job_profiles?.profile_image[0]?.url || jobUserdata?.job_profiles?.profile_image"
                                class="profile-img">

                            <ng-template #showLetter>
                                <div class="fallback-avatar">
                                    <span class="text-initials"> {{ getInitial(jobUserdata?.job_profiles?.full_name) }}
                                    </span>
                                </div>
                            </ng-template>
                            </ng-container>

                                 <ng-template #anonymousImgUser>
                                    <ng-container *ngIf="jobUserdata?.job_profiles?.post_anonymously">
                                        <img class="talent-avatars" *ngIf="jobUserdata?.job_profiles?.dental_professional?.gender === 'male'; else femalePlaceholder"
                                            src="../../../../../../../assets/images/social/male_avatar.png " />
                                        <ng-template #femalePlaceholder>
                                            <img class="talent-avatars"
                                                *ngIf="jobUserdata?.job_profiles?.dental_professional?.gender === 'female';else defaultPlaceholder"
                                                src="../../../../../../../assets/images/social/female_avatar.png" />
                                        </ng-template>
                                        <ng-template #defaultPlaceholder> 
                                            <div style="background-color:#0f0e0e26; height: 100%;width: 100%;border-radius: 50%;">
                                                </div>
                                     </ng-template>
                                
                                    </ng-container>
                                </ng-template>


                        </div>
                    </div>

                    <div class="ml-3">
                        <h3>{{jobUserdata?.job_profiles?.profession_type}}</h3>
                        <h4 *ngIf="!jobUserdata?.job_profiles?.post_anonymously;">{{jobUserdata?.job_profiles?.full_name}}</h4>
                        <h4>{{jobUserdata?.job_profiles?.state}}</h4>


                    </div>
                    <div class="d-flex align-self-baseline flex-column ml-auto text-right">
                        <div class="mb-auto ml-auto">


                            <button mat-icon-button [matMenuTriggerFor]="menu3" (click)="$event.stopPropagation()">
                                <mat-icon>more_horiz</mat-icon>
                            </button>


                            <mat-menu #menu3="matMenu" class="table-action-btn">
                                <!-- <button type="button" class="view" mat-menu-item
                                    [routerLink]="['/jobseek/jobseeks/talents', jobUserdata?.job_profiles?.dental_professional_id]">
                                    <span>View Talent Profile</span>
                                </button> -->

                                <button type="button" class="view" mat-menu-item
                                    (click)="viewTalentProfile(jobUserdata?.job_profiles?.id)">
                                    <span>View Talent Profile</span>
                                </button>
                                <button *ngIf="jobUserdata?.hiring_status==='PENDING'" type="button" class="view"
                                    mat-menu-item
                                    (click)="$event.stopPropagation(); cancelRequest('CANCELLED',jobUserdata.id)">
                                    <span>Cancel</span>
                                </button>
                            </mat-menu>

                        </div>
                        <p class="mt-5">Created : {{jobUserdata.created_at | date : 'dd-MM-yyyy'}}</p>
                    </div>
                </div>
                <span class="EmploymentType" *ngIf="jobUserdata?.job_profiles?.work_type">
                    <span class="fullTime" *ngFor="let type of jobUserdata?.job_profiles?.work_type">
                        {{ type }}
                    </span>
                </span>



                <div class="d-flex" style="margin-top: 15px;">
                    <div class="mr-auto d-flex align-items-center flex-wrap" style="min-width: 180px; gap: 8px;">

                        <div class="orgThemeBtn">{{ jobUserdata?.hiring_status ? jobUserdata?.hiring_status : "ENQUIRY"
                            }}
                        </div>


                        <button class=" blueThemeBtn" style="border: none; margin-left: 5px;"
                            [class.highlight-border]="openAccordionId === jobUserdata.id"
                            (click)="messageAcordion(jobUserdata)"> Message </button>
                        <button class=" blueThemeBtn" style="border: none; margin-left: 5px;"
                            [class.highlight-border]="openEnquiryAccordionId === jobUserdata.id "
                            (click)="EnquiryAcoordion(jobUserdata)">Enquiry</button>

                        <ng-template #emptySpace>
                            <!-- Empty div just to hold the space -->
                            <div style="height: 36px;"></div>
                        </ng-template>
                    </div>

                    <!-- Status Badge -->


                    <!-- Applicant Count -->
                    <!-- <div class="orgThemeBtn mr-2">{{ x?.job_applicants_aggregate.aggregate.count }} Applicants</div> -->

                    <!-- View Details Button -->
                    <div class="blueThemeBtn"
                        [routerLink]="['/jobseek/jobseeks/talents', jobUserdata?.job_profiles?.dental_professional_id]">
                        View Details</div>
                </div>

                <hr>

                <!-- Message Accordion -->
                <div class="message-accordion" *ngIf="openAccordionId === jobUserdata?.id">
                    <div class="messages-container">

                        <div *ngIf="loaderMessage" class="custom-loader custom_logo_loader no-datas">
                            <img src='../../../../../assets/images2/loader.gif' alt="loading" style="width: 10%;" />
                        </div>
                        <!-- Loop through messages -->
                        <div *ngIf="!loaderMessage">
                            <ng-container *ngIf="displayMessage?.length > 0; else noMessage">

                                <div *ngFor="let message of displayMessage"
                                    [ngClass]="message.message_from === loginDetails?.id ? 'message-right' : 'message-left'">

                                    <div class="message-bubble">
                                        <div class="message-header">

                                            <ng-container *ngIf="message?.message_from === loginDetails?.id">
                                                <ng-container *ngIf="loginDetails?.logo?.url; else companyInitials">
                                                    <img class="profile-image" [src]="loginDetails?.logo?.url">
                                                </ng-container>
                                                <ng-template #companyInitials>
                                                    <div class="profile-initials" style="background-color:#ef6a30 ;">
                                                        <span class="text-initials"> {{ getInitial(loginDetails?.name)
                                                            }} </span>
                                                    </div>
                                                </ng-template>
                                            </ng-container>


                                            <ng-container *ngIf="message?.message_from !== loginDetails?.id">
                                                <ng-container
                                                    *ngIf="jobUserdata?.job_profiles?.dental_professional?.profile_image?.url; else profInitials">
                                                    <img class="profile-image"
                                                        [src]="jobUserdata?.job_profiles?.dental_professional?.profile_image?.url">
                                                </ng-container>
                                                <ng-template #profInitials>
                                                    <div class="profile-initials" style="background-color:#007bff;">
                                                        <span class="text-initials"> {{
                                                            getInitial(jobUserdata?.job_profiles?.full_name) }} </span>
                                                    </div>
                                                </ng-template>
                                            </ng-container>

                                            <!-- <img class="profile-image" src="{{x.logo}}" > -->
                                            <span class="message-date">{{ message?.created_at | date :'medium' }}</span>
                                            <button mat-icon-button
                                                *ngIf="message.message_from === loginDetails?.id && !message?.deleted_status"
                                                [matMenuTriggerFor]="message1" (click)="$event.stopPropagation()">
                                                <mat-icon>more_horiz</mat-icon>
                                            </button>
                                        </div>
                                        <div class="message-data">
                                            <p class="message-text" *ngIf="!message?.deleted_status">{{ message.message
                                                }}</p>
                                            <p class="message-text" *ngIf="message?.deleted_status">This message was
                                                deleted</p>
                                        </div>
                                        <p class="message-edit"
                                            *ngIf="!message?.deleted_status && message.created_at !== message.updated_at">
                                            Edited
                                        </p>
                                    </div>

                                    <mat-menu #message1="matMenu" class="table-action-btn">

                                        <button type="button" class="view" mat-menu-item (click)="editMessage(message)">
                                            <span>Edit</span>
                                        </button>
                                        <button type="button" class="view" mat-menu-item
                                            (click)="deleteMessage(message.id)">
                                            <span>Delete</span>
                                        </button>

                                    </mat-menu>
                                </div>
                            </ng-container>
                        </div>

                        <ng-template #noMessage>
                            <div class="no-datas"> No messages </div>
                        </ng-template>

                    </div>
                    <div class="message-input-container">
                        <input type="text" [(ngModel)]="newMessage" placeholder="Type a message..." />
                        <!-- <button class="send-button" (click)="sendMessage(jobUserdata)"> -->
                        <button class="send-button"
                            (click)="EditedMessageId? UpdateMessage(EditedMessageId) :sendMessage(jobUserdata)">
                            <mat-icon class="send-icon">send</mat-icon>
                        </button>

                    </div>
                </div>

                <!--  Enquiry  Accordion-->
                <div class="message-accordion" *ngIf="openEnquiryAccordionId === jobUserdata?.id"
                    style="max-height: 200px; overflow-y: auto;">
                    <div class="messages-container">

                        <div *ngIf="loaderEnquiry" class="custom-loader custom_logo_loader no-datas">
                            <img src='../../../../../assets/images2/loader.gif' alt="loading" style="width: 10%;" />
                        </div>

                        <div *ngIf="!loaderEnquiry">
                            <ng-container *ngIf="enquiryData?.length > 0; else noEnquiry">
                                <div *ngFor="let enquiry of enquiryData">
                                    <div class="message-right" style="max-height: 200px;">
                                        <div class="message-bubble">
                                            <div class="message-header">

                                                <img class="profile-image"
                                                    *ngIf="loginDetails?.logo?.url; else profInitialsEnquiry"
                                                    [src]="loginDetails?.logo?.url">

                                                <ng-template #profInitialsEnquiry>
                                                    <div class="profile-initials" style="background-color:#007bff;">
                                                        <span class="text-initials"> {{ getInitial(loginDetails?.name)
                                                            }}
                                                        </span>
                                                    </div>
                                                </ng-template>

                                                <span class="message-date">{{ enquiry?.created_at | date :'medium' }}
                                                </span>
                                            </div>
                                            <div class="message-data">
                                                <p class="message-text">{{enquiry.enquiry_description}}</p>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                        <ng-template #noEnquiry>
                            <div class="no-datas"> No enquiries </div>
                        </ng-template>

                    </div>

                </div>

            </div>
        </section>
        </ng-container>

         <div *ngIf="loadingUser && hiringListUser.length > 0" class="loading-more" fxLayout="row"
                fxLayoutAlign="center center">
                <img src="../../../../../assets/images2/loader.gif" alt="Loading more..." loading="lazy" width="80px" />
            </div>

        <div *ngIf="endOfDataUser && !loadingUser && hiringListUser?.length > 0" class="text-center py-3 text-muted">
            You've reached the end — no more talents to display
        </div>

      </ng-container>

        

        <ng-template #noDataUser>
            <div class="no-data-wrapper">
                <img src="../../../../../assets/images/icons/no_tasks.svg" alt="No records illustration"
                    class="no-data-image" />
                <div class="no-record-text"> No
                    <span *ngIf="currentUserTab ==='APPROVE' "> - interested</span>
                    <span *ngIf="currentUserTab ==='REJECT' "> - not interested</span>
                    <span *ngIf="currentUserTab ==='PENDING' ">pending</span>
                    <span *ngIf="currentUserTab ==='CANCELLED' ">cancelled</span> talents available at the moment
                </div>
            </div>
        </ng-template>

    </div>
</ng-container>

<div *ngIf="loaderTalent" class="custom-loader custom_logo_loader no-datas">
    <img src='../../../../../assets/images2/loader.gif' alt="loading" style="width: 10%;" />
</div>